var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.entity
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-new": false,
              "show-print": false,
              "show-delete": false,
              "show-save": _vm.entity !== null,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _vm.entity
                  ? _c("estimage-message-new-side-menu", {
                      model: {
                        value: _vm.estimageDetails,
                        callback: function ($$v) {
                          _vm.estimageDetails = $$v
                        },
                        expression: "estimageDetails",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column m-3" },
              [
                _vm.options && _vm.showEditor && _vm.entity
                  ? _c("estimage-message-detail", {
                      attrs: { options: _vm.options },
                      model: {
                        value: _vm.entity.messageJson,
                        callback: function ($$v) {
                          _vm.$set(_vm.entity, "messageJson", $$v)
                        },
                        expression: "entity.messageJson",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "unsaved-modal",
            {
              attrs: { active: _vm.isUnsavedModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isUnsavedModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                skipSave: function ($event) {
                  return _vm.skipSave()
                },
                saveContinue: function ($event) {
                  return _vm.saveContinue()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Unsaved Changes"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "There are unsaved changes. Please select action below"
                  ),
                ]
              ),
            ]
          ),
          _c(
            "save-conflict-modal",
            {
              attrs: { active: _vm.isSaveConflictModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isSaveConflictModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                reload: function ($event) {
                  return _vm.reloadData()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Change conflict"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "The data on the server is newer than the local copy. Please reload local data."
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }